import Table from "../../../../components/molecules/Table";
import classNames from "classnames";
import { BTAG_TIMESTAMP_FORMAT } from "../../constants";
import { formatTimestamp, getTableColumnDateSorter } from "../../helpers";

const BtagTable = ({ data, isLoading, setPage, setPageSize, currentPage }) => {
  const cellContent = ({ text, className = "" }) => (
    <div className={classNames("simple-field", className)}>
      <span>{text}</span>
    </div>
  );

  const colData = [
    {
      title: "Party ID",
      dataIndex: "party_id",
      width: 120,
      render: (text) => cellContent({ text }),
    },
    {
      title: "Partner Code",
      dataIndex: "passcode",
      width: 120,
      render: (text) => cellContent({ text }),
    },
    {
    title: "Btag",
      dataIndex: "btag",
      width: 120,
      render: (text) => cellContent({ text }),
    },
    {
      title: "Timestamp of registration",
      dataIndex: "created_at",
      width: 120,
      render: (text) => cellContent({ text: formatTimestamp(text, BTAG_TIMESTAMP_FORMAT) }),
      sorter: getTableColumnDateSorter("created_at"),
    },
  ];

  return (
    <Table
      className="table__btag-list grid-table"
      colData={colData}
      rowData={data?.data.map((item, i) => ({
        key: i + 1,
        ...item,
      }))}
      paginationSettings={{
        total: data?.total,
        pageSize: data?.per_page,
        current: currentPage,
        showQuickJumper: true,
      }}
      setPageSize={setPageSize}
      setPage={setPage}
      loading={isLoading}
    />
  );
};

export default BtagTable;
